import { Model } from 'pinia-orm';

export default class Organization extends Model {
  static entity = 'organizations';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      slug: this.attr(''),
      businessType: this.attr(null),
      description: this.attr(null),
      phone: this.attr(null),
      address: this.attr(null),
      city: this.attr(null),
      state: this.attr(null),
      status: this.attr(1),
      isPlatformSupplier: this.attr(false),
      createdAt: this.attr(''),
      updatedAt: this.attr(''),
    };
  }
}
